import { Storyboard } from '../../../shared/animations';
import { ProductModelsPanelAnimations } from './AnimatedProductModelsPanel';

export class AnimatedProductModelsPanelState {
  animations: ProductModelsPanelAnimations = new ProductModelsPanelAnimations();

  show: () => Storyboard;
  hide: () => Storyboard;

  constructor() {
    const { show, hide } = this.animations;
    this.show = () => new Storyboard().append(0, show, [hide]);
    this.hide = () => new Storyboard().append(0, hide, [show]);
  }
}
